import { useEffect, useState } from 'react';
import * as api from '../../api'
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { exportCSVFDCandidats } from './CSVExporter';
import FDProjetsList from './FDProjetsList';

const FDAdmin = () => {

    const [event, setEvent] = useState(null);
    // const [pannel, setPannel] = useState("companieslist")
    const [selectedUser, setSelectedUser] = useState(null);
    // const [selectedProjet, setSelectedProjet] = useState(null);
    const [allParticipations, setAllParticipations] = useState([]);
    const [allProjects, setAllProjects] = useState([]);

    //check that the user is admin
    useEffect(() => {
        api.GetCurrentUser().then((response) => {
            console.log(response.data);
            if (response.data.role !== "admin") {
                window.location.href = "/";
            }
        }).catch((error) => {
            console.log(error);
            window.location.href = "/";
        });
    }, [])

    //parse eid from url
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        if (eventIdFromParam) {
            api.getEventById({ id: eventIdFromParam }).then((response) => {
                response.data.displaytype = (response.data.type === "sde" || response.data.type === "sdo") ? "Speed Dating" : "FD 100";
                console.log(response.data);
                setEvent(response.data);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [])

    // get all participations
    useEffect(() => {
        if (!event) return;
        getAllParticipations()
    }, [event])
    function getAllParticipations(){
        api.getParticipatingUsersWithData({ eventId: event._id }).then((response) => {
            // console.log("response.data de get all participations");
            // console.log(response.data);

            const _allParticipations = response.data.map(participation => {
                return {
                    ...participation,
                    data: {
                        projets : participation.participation.data.projets.map(projet_id => {
                            return participation.company.projects.find((p) => p._id === projet_id)
                        }
                    )}
                }
            })

            // console.log("_allParticipations processed")
            // console.log(_allParticipations)

            // for each participation, check that the hsCompany is not missing, if it is, log the participation
            _allParticipations.forEach(participation => {
                if (!participation.hsCompany) {
                    console.log("missing hsCompany for participation : ");
                    console.log(participation);
                }
            })

            setAllParticipations(_allParticipations);
            let _allProjetcs = []
            response.data.forEach(user => {
                if (user.participation.data.projets) {
                    user.participation.data.projets.forEach(project_id => {
                        const project = user.company.projects.find((projet) => projet._id === project_id)

                        _allProjetcs.push({projet : {...project,participationId:user.participation._id}, user : user})
                    })
                }
            })
            // console.log(_allProjetcs)
            setAllProjects(_allProjetcs)
            makePrécisionCSV(_allProjetcs)
        }).catch((error) => {
            console.log(error);
        });
    }

    function makePrécisionCSV(allProjects){
        let csvstring = "id du projet;projet validé;précision renseignée;précision fr;précision en\n"
        allProjects.forEach(project => {
            let id = project.user.participation._id + "_" + project.projet._id
            let validé = project.projet.status === "validé" ? "oui" : "non"
            let precision = project.projet.précisez
            if(precision){
                precision = precision.replace(/(\r\n|\n|\r)/gm, " ")
                precision = precision.replace(/;/gm, " ")

                csvstring += `${id};${validé};${precision};;\n`
            }
        })
        console.log(csvstring)
    }

    //keep selected user in state
    useEffect(() => {
        if (selectedUser) {
            setSelectedUser(allParticipations.find(participation => participation.user._id === selectedUser.user._id))
        }
    }, [allParticipations])

    //update projet status
    function updateProjetStatus(participationId, projetId, status){
        api.updateProjetStatus(participationId, projetId, status).then((response) => {
            console.log(response.data);
            getAllParticipations()
        }).catch((error) => {
            console.log(error);
        });
    }

    //update projet categorie
    function updateProjetCategorie(participationId, projetId, categorie){
        api.updateProjetCategorie(participationId, projetId, categorie).then((response) => {
            console.log(response.data);
            getAllParticipations()
        }).catch((error) => {
            console.log(error);
        });
    }

    //update project verification status
    function updateProjetVerificationStatus(participationId, companyId, projetId, status){
        //step one : update the project in the allProjects array and update the state
        const projet = allProjects.find(projet => projet.projet._id === projetId && projet.user.participation._id === participationId)
        if(projet){
            projet.projet.projet_verifie_fd100_2025 = status
            setAllProjects([...allProjects])
        }

        // //step two : update the project in the database
        api.updateProjetVerificationStatusFD1002025(companyId, projetId, status).then((response) => {
            console.log(response.data);
            // getAllParticipations()
        }).catch((error) => {
            console.log(error);
        });
    }

    //update project candidate as person status
    function updateProjetCandidatingAsStatus(participationId, companyId, projetId, status){
        //step one : update the project in the allProjects array and update the state
        const projet = allProjects.find(projet => projet.projet._id === projetId && projet.user.participation._id === participationId)
        if(projet){
            projet.projet.candidate_as_person_fd100_25 = status
            setAllProjects([...allProjects])
        }

        // //step two : update the project in the database
        api.updateProjetCandidatingAsStatusFD1002025(companyId, projetId, status).then((response) => {
            console.log(response.data);
            // getAllParticipations()
        }).catch((error) => {
            console.log(error);
        });
    }

    function allParticipationsButOnlyWithValidatedProjects(){
        //returns all participations but only with validated projects (status === "validé")
        return allParticipations.map(participation => {
            return {
                ...participation,
                data: {
                    projets : participation.data.projets.filter(projet => projet.status === "validé")
                }
            }
        }).filter(participation => participation.data.projets.length > 0)
    }

    return (
        <div>
            {event ?
                <div>
                    <Link to="/admin/events"><button>← Retour aux événements</button></Link><br/><br/>
                    <h1>{event.title_fr}</h1>
                    <h2>Fin des inscriptions le {new dayjs(event.inscriptions_end_date).format('dddd D MMMM')}</h2>
                 
                    {/* {pannel === "companieslist" && <> */}
                       
                        <br/>
                        <div style={{textAlign:"right"}}>
                            <button onClick={() => exportCSVFDCandidats(allParticipations,"candidats.csv")}>Exporter les candidats</button><br/><br/>
                            <button onClick={() => exportCSVFDCandidats(allParticipationsButOnlyWithValidatedProjects(),"préselections.csv")}>Exporter les préselections</button><br/><br/>
                            {/* <button onClick={() => exportCSVFDCandidats(allParticipations,"lauréats.csv")}>Exporter les lauréats</button><br/><br/> */}
                            {/* <button onClick={() => exportCSVFDCandidats(allParticipations,"catégories.csv")}>Exporter les catégories</button><br/><br/> */}
                        </div>
                        <br/>
                        <div className='flexinfos numbers'>
                            <b>{allParticipations.length}</b>
                            <b>{allProjects.filter(projet => projet.projet.name).length}</b>
                            <b>{allParticipations.filter(part => part.data?.projets?.find(proj => proj?.status === "validé"))?.length}</b>
                            <b>{allProjects.filter(proj => proj.projet.name && proj.projet.status === "validé").length}</b>
                            <b>{allProjects.filter(proj => proj.projet.name && proj.projet.status === "refusé").length}</b>
                            <b>{allProjects.filter(proj => proj.projet.name && proj.projet.status !== "validé" && proj.projet.status !== "refusé").length}</b>
                        </div>
                        <div className='flexinfos'>
                            <p>Candidats</p>
                            <p>Projets</p>
                            <p>Candidats sélectionnés</p>
                            <p>Projets validés</p>
                            <p>Projets<br/>refusés</p>
                            <p>Projets à valider</p>
                        </div>
                        <FDProjetsList 
                            projets={allProjects}
                            event={event}
                            setSelectedUser={setSelectedUser}
                            updateProjetStatus={updateProjetStatus}
                            updateProjetCategorie={updateProjetCategorie}
                            updateProjetVerificationStatus={updateProjetVerificationStatus}
                            updateProjetCandidatingAsStatus={updateProjetCandidatingAsStatus}
                        />
                </div>
            :
                <span>Chargement</span>
            }
        </div>
    );
};

export default FDAdmin;